import * as React from 'react'
import {
  IServiceObject,
  ITeamMemberPermissionState,
  ICreateTeamMemberPermissionDTO,
  IUpdateTeamMemberPermissionDTO
} from '../../../types'
import PreloaderCircle from '../../ui/PreloaderCircle'
import CheckMarker from '../../icons/ui/CheckMarker'
import CrossIcon from '../../icons/ui/CrossIcon'
import UIMessages from 'src/utils/ui-messages'
import FloatingForm from 'src/components/ui/form/FloatingForm'
import Divider from 'src/components/ui/Divider'

export interface TeamMemberPermissionPaneProps {
  id: string
  orgId: string
  permission: ITeamMemberPermissionState
  services: IServiceObject[]
  fetchTeamMemberPermission: (id: string) => void
  createTeamMemberPermission: (tmp: ICreateTeamMemberPermissionDTO) => void
  updateTeamMemberPermission: (tmp: IUpdateTeamMemberPermissionDTO) => void
  fetchServices: (orgId: string) => void
}

interface PermissionItemProps {
  isEnable: boolean
  label: string
}

const ResourcesAndServicesItem: React.FC<PermissionItemProps> = ({ isEnable, label }) => (
  <div className='mbsc-col-12 mbsc-col-lg-6 pt2'>
    <div className='flex items-center'>
      {isEnable ? (
        <CheckMarker className='icon--16x16 mr1' />
      ) : (
        <CrossIcon className='icon--small mr1 svg-fill-red-path' />
      )}
      <span className='font-grey3 ml1'>{label}</span>
    </div>
  </div>
)

class TeamMemberPermissionPane extends React.Component<TeamMemberPermissionPaneProps> {
  public componentDidMount() {
    this.props.fetchServices(this.props.orgId)
    this.props.fetchTeamMemberPermission(this.props.id)
  }

  public render() {
    const { permission, services } = this.props
    const { isFetching } = permission
    const allServices = {}
    services.forEach(svc => {
      allServices[svc.id] = true
    })
    const { resourcePermissions, servicePermission } = permission.permission || {
      resourcePermissions: {
        organization_info: true,
        team_members: true,
        station_user: true,
        services: true,
        riders: true,
        products: true,
        drivers: true,
        vehicles: true,
        trips_management: true,
        billing_management: true,
        global_settings: true,
        promotions: true,
        rider_driver_feedbacks: true
      },
      servicePermission: allServices
    }

    const { resources, service } = UIMessages.teamMember.form.permission
    const serviceItems = services.filter(svc => servicePermission[svc.id])
    const resourcesMapping = this.getResourceMappings(resourcePermissions)

    return (
      <section className='tm-permission-details-container'>
        <FloatingForm>
          <div className='mbsc-grid' style={{ padding: '0' }}>
            {isFetching ? (
              <div className='flex justify-center items-center'>
                <PreloaderCircle loading={isFetching} />
              </div>
            ) : (
              <div className='mbsc-row'>
                {/* RESOURCES */}
                <div className='mbsc-col-12 mbsc-col-lg-6 mbsc-padding'>
                  <p className='bold font-grey3'>{resources}</p>
                  <Divider />
                  <div className='mbsc-row'>
                    {resourcesMapping.map(({ isEnable, label }) => (
                      <ResourcesAndServicesItem key={label} isEnable={isEnable} label={label} />
                    ))}
                  </div>
                </div>
                {/* SERVICE */}
                {resourcePermissions.services && (
                  <div className='mbsc-col-12 mbsc-col-lg-6 mbsc-padding'>
                    <p className='bold font-grey3'>{service}</p>
                    <Divider />
                    <div className='mbsc-row'>
                      {serviceItems.map(({ id, name }) => (
                        <ResourcesAndServicesItem key={id} isEnable={true} label={name} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </FloatingForm>
      </section>
    )
  }

  private getResourceMappings = (resourcePermissions: { [key: string]: boolean }): PermissionItemProps[] => {
    const {
      organization_info,
      team_members,
      station_user,
      services: servicesValue,
      riders,
      products,
      drivers,
      vehicles,
      trips_management,
      billing_management,
      global_settings,
      promotions,
      rider_driver_feedbacks
    } = resourcePermissions

    const {
      billingManagement: billingManagementLabel,
      drivers: driversLabel,
      globalSettings: globalSettingsLabel,
      organizationInfo: organizationInfoLabel,
      products: productsLabel,
      promotions: promotionsLabel,
      riderDriverFeedbacks: riderDriverFeedbacksLabel,
      riders: ridersLabel,
      services: servicesLabel,
      stationUser: stationUserLabel,
      teamMembers: teamMembersLabel,
      tripsManagement: tripsManagementLabel,
      vehicles: vehiclesLabel
    } = UIMessages.teamMember.form.permission

    return [
      { label: organizationInfoLabel, isEnable: organization_info },
      { label: teamMembersLabel, isEnable: team_members },
      { label: stationUserLabel, isEnable: station_user },
      { label: servicesLabel, isEnable: servicesValue },
      { label: ridersLabel, isEnable: riders },
      { label: productsLabel, isEnable: products },
      { label: driversLabel, isEnable: drivers },
      { label: vehiclesLabel, isEnable: vehicles },
      { label: tripsManagementLabel, isEnable: trips_management },
      { label: billingManagementLabel, isEnable: billing_management },
      { label: globalSettingsLabel, isEnable: global_settings },
      { label: promotionsLabel, isEnable: promotions },
      { label: riderDriverFeedbacksLabel, isEnable: rider_driver_feedbacks }
    ]
  }
}

export default TeamMemberPermissionPane



// WEBPACK FOOTER //
// ./src/components/team-members/view/TeamMemberPermissionPane.tsx